import SchemaUpdate from './SchemaUpdate';

export default SchemaUpdate;
